<div class="content-wrapper table-full-bx">
    <div class="page-content account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        <div class="iboxcontent">
                            <h3>Account Settings</h3>
                        </div>
                        <!-- Account settings  -->
                        <div class="row">
                            <div class="col-lg-3 col-sm-12">
                                <!-- Tabs nav -->
                                <div class="nav  nav-pills nav-pills-custom pills-custom">
                                    <a class="nav-link mb-3 p-3 active" href="javascript:void(0);"
                                        routerLink="/account-settings/change-password">
                                        <span class=" ">Change password</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/notification">

                                        <span class=" ">Notifications</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/save-card"
                                        *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden>

                                        <span class=" ">Saved cards</span>
                                    </a>



                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/inventory-history"
                                        *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)">

                                        <span class="">Subscriptions</span>
                                    </a>
                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/billing-address"
                                        *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'">

                                        <span class=" ">Billing address</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/my-templates"
                                        *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'">

                                        <span class=" ">My templates</span>
                                    </a>

                                </div>
                            </div>
                            <div class="col-lg-6 col-sm-12 tabwidth marginstart">
                                <!-- Tabs content -->
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade  bg-box show active ">

                                        <div class=" subHeader">
                                            <h2 class="mainTitle"> Change Password</h2>

                                        </div>

                                        <form [formGroup]="form" (ngSubmit)="resetPassword()">
                                            <div class="form-group">
                                                <label>Current Password <span class="orange">*</span></label>
                                                <input type="{{showPwd?'text':'password'}}" class="form-control"
                                                    name="password" placeholder="Enter password" id="password"
                                                    formControlName="password" (keyup)="keyup($event)" />
                                                <a href="javascript:void(0);" [class]="showPwd? 'hide':'show'"
                                                    (click)="showPwd= !showPwd">
                                                    <img class="hide"
                                                        [src]="showPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'"
                                                        alt="password">
                                                    <i></i>
                                                </a>
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="form.controls['password'].hasError('required') && showError">
                                                *Please enter current password.
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="form.value.password.includes(' ') && showError">
                                                *Space not allowed in password.
                                            </div>
                                            <div class="form-group">
                                                <label>New Password <span class="orange">*</span></label>
                                                <input type="{{showNewPwd?'text':'password'}}" class="form-control"
                                                    name="newPassword" placeholder="Enter password" id="newPassword"
                                                    formControlName="newPassword" (keyup)="keyup($event)" />
                                                <a href="javascript:void(0);" [class]="showNewPwd? 'hide':'show'"
                                                    (click)="showNewPwd= !showNewPwd">
                                                    <img class="hide"
                                                        [src]="showNewPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'"
                                                        alt="password">
                                                    <i></i>
                                                </a>
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="form.controls['newPassword'].hasError('required') && showError">
                                                *Please enter new password.
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="form.value.newPassword.includes(' ') && showError">
                                                *Space not allowed in password.
                                            </div>
                                            <div class="form-group mb-3">
                                                <label>Confirm Password <span class="orange">*</span></label>
                                                <input type="{{showReNewPwd?'text':'password'}}" class="form-control"
                                                    name="password2" placeholder="Enter password" id="password2"
                                                    formControlName="password2" (keyup)="keyup($event)" />
                                                <a href="javascript:void(0);" [class]="showReNewPwd? 'hide':'show'"
                                                    (click)="showReNewPwd= !showReNewPwd">
                                                    <img class="hide"
                                                        [src]="showReNewPwd? '../../../assets/images/password.svg':'../../../assets/images/ic_eye_open.svg'"
                                                        alt="password">
                                                    <i></i>
                                                </a>
                                            </div>
                                            <div class="text-danger"
                                                *ngIf="(showError) && ((form.value.newPassword && form.value.password2) && (form.value.newPassword != form.value.password2))">
                                                *Password does not match. Please try again.
                                            </div>
                                            <ul class="selectpasswordType">
                                                <li
                                                    [ngClass]="form.value.newPassword.length == 0 ? '': (form.value.newPassword.length > 7 ? 'active':'text-danger')">
                                                    Minimum 8 characters </li>
                                                <li
                                                    [ngClass]="form.value.newPassword.length == 0 ? '' : (upper > 0 ? 'active' : 'text-danger')">
                                                    Minimum 1 uppercase </li>
                                                <li
                                                    [ngClass]="form.value.newPassword.length == 0 ? '' : (number > 0 ? 'active' : 'text-danger')">
                                                    Minimum 1 number </li>
                                                <li
                                                    [ngClass]="form.value.newPassword.length == 0 ? '' : (special > 0 ? 'active' : 'text-danger')">
                                                    At least 1 special character </li>
                                            </ul>

                                            <div class="form-group mt-5">
                                                <!-- <a href="javascript:void(0);" routerLink="settings" class="commonBtn mt-5"> Save Changes </a> -->
                                                <input type="submit" value="Save Changes" class="commonBtn mt-5" />
                                            </div>

                                        </form>

                                    </div>
                                </div>

                            </div>

                        </div>
                        <!-- End -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>